<template lang="html">
   <div class="animated fadeIn">
    <div>
      <div class="col-12">
        <div class="row">
          <card-component :block="false" title="Lista de e-commerces" subtitle="" :col="{xs: 12}" :buttonNew="[]">
            <ecommerce-list-component></ecommerce-list-component>
          </card-component>
        </div>
      </div>
    </div>
   </div>
</template>

<script>
import Card from '../../partial/card/Card.vue'
import EcommerceList from '../../partial/ecommerces/EcommerceList'
// v-if="$auth.check('ROLE_ADMIN')"
export default {
  components: {
    'card-component': Card,
    'ecommerce-list-component': EcommerceList
  }
}
</script>

<style>
   .card-header {
     line-height: inherit;
   }
</style>



// WEBPACK FOOTER //
// src/components/pages/ecommerces/EcommerceList.vue